import { Account, MessageType, HousingCompany, AccountRegistrationStatus } from "@/models";
import axios from "axios";

export default class AccountService {
    // public async GetAccount(userId: number): Promise<Account | null> { 
    //     const account = (await axios.get("accounts/by-user-id", { params: { userId }})).data;
    //     return account;
    // }

    // public async IsAccountRegistered(email: string, housingCompanyId: number): Promise<boolean | null> {
    //     const { isRegistered } = (await axios.get<AccountRegistrationStatus>("accounts/registration-status", {
    //             params: {
    //                 email,
    //                 housingCompanyId,
    //             }
    //         }
    //     )).data;

    //     return isRegistered;
    // }

    
}
